import { parsePhoneNumber, ParseError } from 'libphonenumber-js';
window.fsSimplyBook = window.fsSimplyBook || {};
window.fsSimplyBook.selectedBooking = null;
window.fsSimplyBook.client = {

	/**
	 * Checks availability of store (resource) timeslots.
	 *
	 * @param {*} resourceId
	 * @returns
	*/
	getWorkCalendar: async ( year, month, resourceId ) => {

		var simply_book_params 	= 	[ year.toString(), month.toString(), resourceId ];

		var data = {
			'action': 'get_work_calendar',
			'contentType': "application/json; charset=utf-8",
			"accept": "application/json",
			'simply_book_params': simply_book_params,
			'_ajax_nonce': fsSimplyBook.nonce
		};
		
		const response = await jQuery.post(fsSimplyBook.ajaxurl, data);	
		
		return response;

	},
	getStartTimeMatrix: async ( from, to, serviceId, resourceId, count ) => {
		
		var simply_book_params 	= 	[ from, to, serviceId, resourceId, count ];
		
		var data = {
			'action': 'get_start_time_matrix',
			'contentType': "application/json; charset=utf-8",
			"accept": "application/json",
			'simply_book_params': simply_book_params,
			'_ajax_nonce': fsSimplyBook.nonce
		};
		
		const response = await jQuery.post(fsSimplyBook.ajaxurl, data);	
		
		return response;
	},
	getAdditionalField: async (selected_service) => {
		// clearing the previous fields if any
		var extra_fields_wrapper = document.getElementById("extra-fields");
		extra_fields_wrapper.innerHTML = '';

		var simply_book_params 	= 	[ selected_service ];

		var data = {
			'action': 'get_additional_fields',
			'contentType': "application/json; charset=utf-8",
			"accept": "application/json",
			'simply_book_params': simply_book_params,
			'_ajax_nonce': fsSimplyBook.nonce
		};
		
		jQuery.post(fsSimplyBook.ajaxurl, data).then( ( response ) => {
			// append the response field inside form
			response.forEach( function( data ) {
				jQuery(extra_fields_wrapper).append(data);
			} );
		});
	},
	getFormattedDate: (date) => {
		return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	},
	updateTimeSlots: ( date, timeframes ) => {

		let timeActionsEl = document.querySelector( '.time-options' );
		
		// Timeslots available, scoped to the specific day represented by `date`
		timeActionsEl.innerHTML = '';
		timeActionsEl.classList.remove('fade-in-text');
		
		Object.keys(timeframes).forEach( ( dateSlot, index ) => { 
			timeframes[dateSlot].forEach( (timeSlot) => { 
				timeActionsEl.innerHTML += '<div class="time" data-start="' + timeSlot + '" ><span>' + timeSlot + '</span></div>';
			} ) 
		});
		
		let timeSlots = document.querySelectorAll( '.time-options .time' );

		timeSlots.forEach( time => {

			time.addEventListener( 'click', (evt) => {
				if ( evt.target.classList.contains( 'selected' ) ) {
					return;
				}

				let selected = document.querySelector( '.time-options .selected' );

				if ( selected !== null ) {
					selected.classList.remove('selected');
				}

				evt.target.parentNode.classList.add('selected');

				let bookingTimes = document.querySelectorAll( '.booking-time' );

				window.fsSimplyBook.selectedBooking = time;

				bookingTimes.forEach( element => {
					element.innerText = evt.target.innerText;
				} );
			} );
		} )
			
		// Render the default selected time on each load.
		let defaultSelectedTime = document.querySelector('.time.selected span');
		let defaultBookingTime = document.querySelectorAll('.booking-time');
		if ( null !== defaultBookingTime && null !== defaultSelectedTime ) {
			defaultBookingTime.forEach((timeSlot, index) => {
				timeSlot.innerHTML = defaultSelectedTime.innerHTML;
				console.log('worked');
			});	
		}
	},
	// Updates booking dates in DOM on page load and date selection.
	updateBookingDate: ( date, data ) => {
		let bookingDates = document.querySelectorAll( '.booking-date' );

		bookingDates.forEach( element => {
			element.innerText = new Date( date ).toLocaleDateString( 'en-US', { month: 'long', day: 'numeric', year: 'numeric' } );
		} );
	},
	getSelectedService: (evt) => {
		if ( evt ) {
			window.selectedService = evt.currentTarget.getAttribute("data-location-id")
		} 

		return window.selectedService;
	},
	getSelectedServiceText: (evt) => {
		return evt.currentTarget.getAttribute("data-location-name")
	},
	
	getAdditionalFieldValues: () => {
		var field_values = {};
		
		jQuery('#extra-fields input, #extra-fields select, #extra-fields textarea').each(function () {
			var val = '';
			if (jQuery(this).attr('type') == 'checkbox') {
				if (jQuery(this).is(':checked')) {
					val = 1;
				} else {
					val = 0;
				}
			} else {
				val = jQuery(this).val();
			}
			field_values[jQuery(this).attr('name')] = val;
		});

		return field_values;
	},
	upadateServiceDetailText: (evt) => {
		if ( evt ) {
			window.serviceDetailText = evt.currentTarget.getAttribute("data-location-name")
		}
		jQuery( ".service-detail" ).html(window.serviceDetailText);
	},
	/**
	 * 
	 * @url https://stackoverflow.com/a/32180863
	 *
	 * @param {duration} Time in milliseconds
	 * @returns converted time in hours, min, sec format
	 */
	msToTime: (duration) => {
		var milliseconds = Math.floor((duration % 1000) / 100),
		  seconds = Math.floor((duration / 1000) % 60),
		  minutes = Math.floor((duration / (1000 * 60)) % 60),
		  hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
	  
		hours = (hours < 10) ? "0" + hours : hours;
		minutes = (minutes < 10) ? "0" + minutes : minutes;
		seconds = (seconds < 10) ? "0" + seconds : seconds;

		var text = '(approx ';

		if (hours >= 1) {
			var hour_text = (hours == 1) ? 'hour and' : 'hours and' ;
			text += hours + " " + hour_text;
		}

		if (minutes >= 1) {
			var minutes_text = (minutes == 1) ? 'minute' : 'minutes' ;
			text += minutes + " " + minutes_text;
		}
		
		text += ' appointment)';

		return text;
		// return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
	},
	/**
	 * init calendar with first working day of store.
	 *
	 * @param {*} resourceId
	 * @returns
	 */
	initCalendar (sDate) {
		
		let calendarTarget 		= document.getElementById('simplybook-calendar');
		var workCalendarData 	= window.fsSimplyBook.getWorkCalendar;
		var lz_resourceId 	 	= window.fsSimplyBook.resourceId;

		if ( null === calendarTarget ) {
			return;
		}

		let calendar = jsCalendar.new(
			calendarTarget,
			sDate,
			{
				min: sDate
			}
		);

		// when month change generate a new request but this time using JS
		calendar.onMonthChange(function(event, date){

			var calendarTarget = document.getElementById("simplybook-calendar");

			calendarTarget.classList.add('disabled');

			// get selected date and year
			var month = date.getMonth() + 1;
			var year  = date.getFullYear();
			
			var lz_getWorkCalendar 	 = window.fsSimplyBook.client.getWorkCalendar( year, month, lz_resourceId );
			
			lz_getWorkCalendar.then( ( response ) => {
				workCalendarData = response;
				// refresh so that DateRender is called
				calendar.refresh();

				calendarTarget.classList.remove('disabled');
			});

		});

		// Select date and fill timeslots
		calendar.onDateClick(function(event, date){

			const { target } = event;
			

			if ( target.classList.contains( 'available' ) || target.classList.contains( 'jsCalendar-current' )  ) {
				let selected = target.parentNode.parentNode.querySelector( '.selected' );
				if ( selected !== null ) {
					selected.classList.remove('selected');
				}
				target.classList.add('selected');

				
				let bookingDates = document.querySelectorAll( '.booking-date' );
				bookingDates.forEach( element => {
					element.innerText = new Date( date ).toLocaleDateString( 'en-US', { month: 'long', day: 'numeric', year: 'numeric' } );
				} );

				var getSelectedService 	 = window.fsSimplyBook.client.getSelectedService();
				var formatted_date 		 = window.fsSimplyBook.client.getFormattedDate(new Date( date ));;
				var getStartTimeMatrix 	 = window.fsSimplyBook.client.getStartTimeMatrix( formatted_date, formatted_date, getSelectedService, lz_resourceId, 1 );
				
				// show waiting text
				var timeActionsWrapper = document.querySelector( '.time-options' );
				timeActionsWrapper.classList.add('fade-in-text');
				timeActionsWrapper.innerHTML = 'Please wait...';

				getStartTimeMatrix.then( ( response ) => {
					window.fsSimplyBook.client.updateTimeSlots(date, response);
				});
				
			}
			
			// show the time frames 
			document.querySelector( ".time-selector-contain" ).classList.remove( "hide-booking-content" );
		});

		calendar.onDateRender(function(renderedDate, element, info) {
			
			Object.keys(workCalendarData).forEach(function(availableDate) {
				
				if ( new Date() > renderedDate ) return;


				// if ( availableDate ) return;
				
				// check for the off days and skip them
				if ( workCalendarData[availableDate].is_day_off ) {
					var is_day_off = parseInt(workCalendarData[availableDate].is_day_off);
					if (is_day_off) return;
				}

				let availabilityDateObject = new Date( availableDate );
				if (
					! element.classList.contains( 'available' ) &&
					renderedDate.getYear() === availabilityDateObject.getYear() &&
					renderedDate.getMonth() === availabilityDateObject.getMonth() &&
					renderedDate.getDate() === availabilityDateObject.getDate()
				) {
					element.classList.add( 'available' );
				}
			  
			});
		});
		
		calendar.refresh();

		return calendar;
	},
	/**
	 * Appends the country code to phone number input field based on top level domain for .ie and .uk
	 *
	 * @param {*} data
	 * @returns
	 */
	appendCountryCode: () => {

		let re=/\.([^\.]+?)$/;		
		let domain = re.exec(location.hostname);
		let country_code;
		
		if ( domain[1] == 'ie' || domain[1] == 'uk' ) {
			
			if ( domain[1] == 'ie' ) {
				country_code = '+353';
			}
			if ( domain[1] == 'uk' ) {
				country_code = '+44';
			}
			
			document.getElementById( 'tel' ).value = country_code;
		} 
	},

	/**
	 * Checks if there is a country code at all
	 *
	 * @param {*} data
	 * @returns countrycode
	 */
	 checkCountryCode: () => {
		
		let phone = document.getElementById( 'tel' ).value;
		let validationEl = document.getElementById( "validation-text" );

		try {

			let phone_validate = parsePhoneNumber(phone);
			return phone_validate.isValid() ? true : false;

		} catch (error) {
			
			if (error instanceof ParseError) {
				validationEl.innerHTML = "Invalid phone number with error message: " +  error.message;
				validationEl.classList.remove('hide');
			} 
			
			return false;
		}
	},
	/**
	 * Create booking in SimplyBook
	 *
	 * @param {*} data
	 * @returns
	 */
	createBooking: async () => {

		var selected_service = 	window.fsSimplyBook.client.getSelectedService();
		var location_id 	 = 	window.fsSimplyBook.resourceId;
		
		// get the selected date
		var start_date		= 	document.querySelector(".booking-date").innerHTML; //  Format: "2022-04-14"
		start_date			= 	window.fsSimplyBook.client.getFormattedDate( new Date(start_date) );

		// get the selected time
		var start_time 		= 	document.querySelector(".booking-time").innerHTML; //  Format: "09:15:00"
		
		// get the user form input
		var client_data 	= {
								'name': document.getElementById( 'full-name' ).value,
								'email': document.getElementById( 'email-address' ).value,
								'phone': document.getElementById( 'tel' ).value
							};
		
		var additional_field_values = window.fsSimplyBook.client.getAdditionalFieldValues();
		var count = 1;

		var simply_book_params =  [ selected_service, location_id, start_date, start_time, client_data, additional_field_values, parseInt(count) ];

		var postData = {
			'action': 'create_booking',
			"content-type": "application/json; charset=UTF-8",
			"accept": "application/json",
			'simply_book_params': simply_book_params,
			'_ajax_nonce': fsSimplyBook.nonce
		};
		
		
		const response = await jQuery.post(fsSimplyBook.ajaxurl, postData);	
		
		return response;
	}
};

document.addEventListener('DOMContentLoaded', function() {
	var default_selected_service_text;
	var initCalendar;
	
	// STEP ZERO: show calendar services dropdown and add init calendar on change event

	const location_select_btns = document.querySelectorAll( '.select-service' );

	window.fsSimplyBook.client.appendCountryCode();

	location_select_btns.forEach(el => el.addEventListener( 'click', (evt) => {	
		
		evt.preventDefault();

		default_selected_service_text = window.fsSimplyBook.client.getSelectedServiceText(evt);
		
		// set selected service text on booking step
		window.fsSimplyBook.client.upadateServiceDetailText(evt);

		const start_date_data 		=  new Date( window.fsSimplyBook.firstDay );
		const work_calendar_data  	=  window.fsSimplyBook.getWorkCalendar;

		// starrt working date of store is important for whole booking process
		if ( ! start_date_data ) return;

		if ( ! initCalendar ) {
			// init calendar with first working day of store
			initCalendar = window.fsSimplyBook.client.initCalendar(start_date_data);
		}
		
		window.fsSimplyBook.client.updateBookingDate( start_date_data, work_calendar_data );

		// check if there are any extra fields like "comments" - if yes, append those into the form
		window.fsSimplyBook.client.getAdditionalField( window.fsSimplyBook.client.getSelectedService(evt) );
		
		// show the next step
		document.querySelector( '.step-zero' ).style.display = 'none';
		document.querySelector( '.step-one' ).style.display = 'block';

		if ( document.querySelector( ".step-one.hide-booking-content" ) ) {
			document.querySelector( ".step-one.hide-booking-content" ).classList.remove( "hide-booking-content" );
		}

		window.scrollBy(0, 50);
		

	} ) );
	  
	

	// STEP ONE > STEP TWO (Select and Continue)
	document.querySelector( '.time-actions .btn' ).addEventListener( 'click', (evt) => {
		document.querySelector( '.step-one' ).style.display = 'none';
		document.querySelector( '.step-two' ).style.display = 'block';
	} );

	// STEP TWO > STEP ZERO (Cancel)
	// STEP THREE > STEP ZERO (Cancel)
	// STEP ONE > STEP ZERO (Cancel)
	document.querySelectorAll( '.step-one .step1 a, .step-two .step1 a, .step-one .time-actions .text-link, .step-two .form-actions .text-link' ).forEach(box => 
		box.addEventListener("click", () => {
				document.querySelector( '.step-zero' ).style.display = 'block';
				document.querySelector( '.step-one' ).style.display = 'none';	
			}
		)
	);

	// STEP TWO > STEP ONE (Cancel)
	document.querySelector( '.step-two .step2 a' ).addEventListener( 'click', (evt) => {
		document.querySelector( '.step-one' ).style.display = 'block';
		document.querySelector( '.step-two' ).style.display = 'none';	
	} );

	// STEP TWO > STEP THREE (Create Booking)
	document.querySelector( '.step-two .form-actions .btn' ).addEventListener( 'click', (evt) => {
		
		let waitTarget = document.getElementById("waiting-text");
		let form = document.querySelector( '.step-two form' );
		let validationEl = document.getElementById("validation-text");
		

		if ( ! form.checkValidity() ) {
			return form.reportValidity();
		}

		let countryCode = window.fsSimplyBook.client.checkCountryCode();

		if ( false === countryCode ) {
			waitTarget.classList.add('hide');
			return;
		}

		validationEl.classList.add('hide');
		waitTarget.classList.remove('hide');

		var createBookingData = window.fsSimplyBook.client.createBooking();
		
		createBookingData.then( ( response ) => {
			waitTarget.classList.add('hide');
			
			console.log( "Response Received:" );
			console.log( response );
			
			console.log( "Stringify:" );
			console.log( JSON.stringify(response, null, 4) );
			
			if ( response.bookings ) {

				if ( response.bookings[0] === undefined ) {
					console.log( JSON.stringify(response, null, 4) );
					waitTarget.innerHTML = "An error occurred! Please contact us. ";
					waitTarget.innerHTML += JSON.stringify(response, null, 4);
					
					waitTarget.classList.remove('hide');	

					return;
				}

				var booking = response.bookings[0];

				var start_time  = new Date( booking.start_date_time );
				var end_time  	= new Date( booking.end_date_time );

				var duration = window.fsSimplyBook.client.msToTime( end_time - start_time );
				
				jQuery(".booking-duration").html(duration);

				document.querySelector( '.step-two' ).style.display = 'none';
				document.querySelector( '.step-three' ).style.display = 'block';	
			} else {
				waitTarget.innerHTML = "An error occurred! Please contact us."
				waitTarget.classList.remove('hide');
			}

			
		});

	} );
	
} );
